//
// PromptDefinition.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../dataDefinition/DataItemOrPromptDefinition";
import "../dataDefinition/DataDefinition";
import "../dataDefinition/DataItem";
import "../common/values/DefaultValue";
import "../common/constraints/AbstractConstraintType";
import "../common/BIRDDataType";
import "./CurrentValueSource";

var PromptDefinition = createModule("BIRD::PromptDefinition", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::DataItemOrPromptDefinition"], EventDispatcher, [
    ,
    {
        measureVariable: 1,
        hidden: 2,
        isParameter: 2,
        defaultValue: 1,
        maxVariable: 1,
        dataType: 4,
        minVariable: 1,
        format: 7,
        labelVariable: 1,
        currentValueSource: 1,
        valueVariable: 1,
        labelFormatted: 2,
        dataDefinition: 1,
        valueFormatted: 2,
        constraint: 1,
        multiValued: 2,
        isValueFixed: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default PromptDefinition;
